import type { ReactElement } from 'react';
import { clsx } from 'cn';

export const BridgeAddButton = ({
  onSearch,
  isPtzoptics
}: {
  onSearch: () => void;
  isPtzoptics: boolean;
}): ReactElement => {
  return (
    <button
      className={clsx(
        'aspect-square h-32 w-32 rounded-4 text-foreground transition-colors duration-250',
        {
          'bg-base-50 hover:bg-base-200': !isPtzoptics,
          'bg-base-200 hover:bg-base-300': isPtzoptics
        }
      )}
      onClick={onSearch}
    >
      <i className='i-ion-plus text-lg text-white' color='white' />
    </button>
  );
};
